import { IVDPfooter } from "../../apis/useGetConfig";
import { Nullable } from "../../common/types/types";

export interface ILocation {
	id: string;
	name: string;
	outletid?: string;
	description?: string;
	cluster?: string;
}

export enum APP_MODE {
	VIEW = "VIEW",
	NORMAL = "NORMAL",
}
export interface IStall {
	mode: IStallMode;
	name?: string;
	image_url?: string;
}

export enum IStallMode {
	FAIRPRICE = "fairprice",
	WANG = "wang",
	FLINT = "flint",
	SHABUDAY = "ShabuDays",
	KOKORO = "kokoro",
	TORIKIZOKU = "torikizoku",
	NULL = "",
}

export interface IBanner {
	id: string;
	type: string;
	image_url: string;
}

export interface IConfigState {
	user: {
		session_id: Nullable<number | string>;
		role: CONFIG_ROLES;
	};
	theme: "light";
	table: Nullable<string>;
	location: ILocation;
	isLoading: boolean;
	errorMessage: Nullable<string>;
	count: number;
	config: IAppConfig;
	paymentMethods: IPaymentMethodEntry[];
	appMode: APP_MODE;
	stallMode: Nullable<IStallMode>;
	inited: boolean;
	qrSession: Nullable<IQrSession>;
}

/**
 * One entry of the backend's payment_methods list (top level of /v1/location).
 * qr_enabled is qrokoro's column; sok/kpos belong to the other frontends.
 */
export interface IPaymentMethodEntry {
	method: string;
	description: string;
	sok_enabled: boolean;
	kpos_enabled: boolean;
	qr_enabled: boolean;
}

export enum CONFIG_ROLES {
	GUEST = "guest",
	MEMBER = "member",
}

export interface IBannerItem {
	id: string;
	src: string;
	bannerClickData?: {
		type: "item" | "category";
		data: string;
	};
}

export interface IStallConfig {
	name: string;
	image_url: string;
	mode: Nullable<IStallMode>;
	address?: Nullable<string[]>;
}

export interface IItemLimitPerPax {
	categories: number[];
	max: number;
}

export interface IVirtualCategory {
	tag_key: string;
	title: string;
	title_cn: string;
	display_order: number;
	description?: string;
	description_cn?: string;
}

export interface IAppConfig {
	/** Which LinkPay flow serves a venue offering linkpay: true = v3 (LinkPass); absent or false = v2 (injected cookies). A venue joins v3 by opting in. */
	linkpay_v3_enabled?: boolean;
	// For disable set item's alacarte_bmi
	hidden_alacarte_bmi?: number[];
	banner: IBannerItem[];
	showBanner: boolean;
	stall: IStallConfig;
	VDPfooter: Nullable<IVDPfooter>;
	enable_qrokoro: boolean;
	takeaway_fee: number;
	bcrs_deposit_rate: number;
	send_linkpay_accesstoken?: boolean;
	show_initial_takeaway_selection?: boolean;
	adyen_merchant_name: Nullable<IAdyenMerchant>;
	allow_takeaway: boolean;
	language_select: boolean;
	dev_tool?: boolean;
	show_dining_timer?: boolean;
	show_order_history?: boolean;
	item_limit_per_pax?: IItemLimitPerPax[];
	dynamic_qr?: boolean;
	show_virtual_category?: boolean;
	virtual_category?: IVirtualCategory[];
	allow_virtual_items?: boolean;
	enable_cart_sharing?: boolean;
	// LinkPay wallet payments (/v3/linkpay) mint tokens against LinkPay's own Adyen
	// account, not the stall's. Absent until LinkPay provisions the venue — wallets
	// are then simply not offered.
	linkpay_adyen_merchant_name?: Nullable<ILinkpayAdyenMerchant>;
	show_category_description?: boolean;
}

export interface IAdyenMerchant {
	name: string;
	mid: string;
	client_key: string;
}

/**
 * LinkPay's own Adyen merchant setup — everything the wallet buttons need.
 * Env-style keys match the backend's /v1/location payload verbatim.
 */
export interface ILinkpayAdyenMerchant {
	ADYEN_MERCHANT_NAME: string;
	ADYEN_CLIENT_KEY: string;
	/** Apple Pay merchantIdentifier (merchant.com.…). */
	ADYEN_MERCHANT_IDENTIFIER: string;
	/** Google Pay merchantId. */
	ADYEN_MERCHANT_ID: string;
	/** Google Pay gatewayMerchantId — the Adyen merchant account. */
	ADYEN_GATEWAY_MERCHANT_ID: string;
	/** Venue opt-in for the Apple Pay button: offered only when explicitly true. */
	APPLE_PAY?: boolean;
	/** Venue opt-in for the Google Pay button: offered only when explicitly true. */
	GOOGLE_PAY?: boolean;
}

export interface IQrSession {
	qrs_id: string;
	pax: number;
	table: string;
	status: string;
	bb_uuid: string;
	order_until: string;
}
